import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useSelector } from 'react-redux';
import { makeGetDetailInformation, makeGetExpertReviews, makeGetProduct, } from '../../../redux/product/selectors/ProductSelector';
import { getSwatchUrlByProductCode } from '../../../util/ImageUtil';
import { concatUrls } from '../../../util/UrlUtil';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
const generateNoteSchema = (notes) => ({
    '@type': 'ItemList',
    itemListElement: notes.map((note, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: note,
    })),
});
const generateReviewSchema = (review) => {
    var _a, _b;
    return ({
        '@type': 'Review',
        name: review.title,
        author: {
            '@type': 'Person',
            name: review.expertInfo.firstName,
        },
        description: review.heading,
        reviewBody: review.reviewText,
        positiveNotes: ((_a = review.pros) === null || _a === void 0 ? void 0 : _a.length) ? generateNoteSchema(review.pros) : undefined,
        negativeNotes: ((_b = review.cons) === null || _b === void 0 ? void 0 : _b.length) ? generateNoteSchema(review.cons) : undefined,
    });
};
const ProductLD = props => {
    var _a, _b, _c, _d;
    const detailInformation = useSelector(makeGetDetailInformation());
    const expertReviews = useSelector(makeGetExpertReviews());
    const product = useSelector(makeGetProduct());
    const { canonicalUrl, productImageConfig } = useAemConfig();
    const selectedColorVariation = (_a = product.productColorVariations) === null || _a === void 0 ? void 0 : _a.find(({ colorId }) => colorId === product.selectedColorId);
    if (typeof props.data.brand === 'object' &&
        'url' in props.data.brand &&
        ((_c = (_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 : _b.brand) === null || _c === void 0 ? void 0 : _c.url) === null &&
        ((_d = detailInformation === null || detailInformation === void 0 ? void 0 : detailInformation.brand) === null || _d === void 0 ? void 0 : _d.relativePath)) {
        const url = new URL(canonicalUrl);
        props.data.brand.url = concatUrls(url.origin, detailInformation.brand.relativePath);
    }
    if (expertReviews.length > 0) {
        props.data.review =
            expertReviews.length > 1 ? expertReviews.map(generateReviewSchema) : generateReviewSchema(expertReviews[0]);
    }
    if (selectedColorVariation) {
        props.data.colorSwatch = getSwatchUrlByProductCode(product.productCode, selectedColorVariation.swatch, productImageConfig.cdnDomains);
    }
    const jsonLDScript = `<script type="application/ld+json">${JSON.stringify(props.data)}</script>`;
    return _jsx(HtmlInclude, { htmlFragment: jsonLDScript });
};
export default ProductLD;
